import { eventChannel } from "redux-saga";
import { put, call, takeLatest, take, fork } from "redux-saga/effects"
import { IUser } from "./types";
import { api, firebase } from "../../firebase";
import { usersCollectionKey } from "../../firebase/api";
import { fetchUserByIdAsyncActions, loginAsyncActions, logoutAsyncActions } from "./actions";
import { push } from "connected-react-router";
import * as routes from "../../constants/routes";


function channel() {
    const auth = firebase.auth

    return eventChannel(emit => {
        return auth.onAuthStateChanged(
            user => emit({ user }),
            error => emit({ error }),
        );
    });
}

function* loginStatusWatcher() {
    // events on this channel fire when the user logs in or logs out
    // @ts-ignore
    const chan = yield call(channel)

    try {
        while (true) {
            const { user }: { user: firebase.User } = yield take(chan)

            if (user && user.email) {
                let authUser: IUser = {
                    id: user.uid,
                    email: user.email,
                    roles: {},
                    displayName: user.displayName,
                    photoURL: user.photoURL,
                    created: null,
                    updated: null
                }
                try {
                    // @ts-ignore
                    const dbUser = yield call(api.fetchDocById, usersCollectionKey, user.uid)
                    authUser = { ...authUser, ...dbUser }
                } catch (e) {
                    console.log(e)
                }
                yield put(loginAsyncActions.success({ user: authUser }))
                // yield put(push(routes.ADS));
            } else {
                yield put(logoutAsyncActions.success({}))
                yield put(push(routes.SIGN_IN));
            }
        }
    } catch (e) {
        console.log(e)
        chan.close()
    } finally {
        chan.close()
    }
}

function* fetchUserByIdSaga(action: ReturnType<typeof fetchUserByIdAsyncActions.request>): Generator {
    try {
        // @ts-ignore
        const data: IUser = yield call(api.fetchDocById, usersCollectionKey, action.payload.id)
        yield put(fetchUserByIdAsyncActions.success({ user: data }))
    } catch (e: any) {
        yield put(fetchUserByIdAsyncActions.failure(e))
    }
}

function* userActionWatcher() {
    yield fork(loginStatusWatcher)

    yield takeLatest(fetchUserByIdAsyncActions.request, fetchUserByIdSaga)

}

export default userActionWatcher;